// src/api/axios.js
import axios from "axios";
import keycloak from "../auth/keycloak";
import { getCurrentTenant } from "../hooks/useCurrentTenant";
import { isEmbedded, getEmbeddedToken } from "../auth/embeddedAuth"; // adjust path to your embedded-auth file

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
});

const getToken = async () => {
  if (isEmbedded()) return getEmbeddedToken(); // token comes from the host app

  if (!keycloak?.token) return null;
  try {
    await keycloak.updateToken(5); // refresh if it expires within 5 s
  } catch (error) {
    console.error("Token refresh failed", error);
  }
  return keycloak.token;
};

api.interceptors.request.use(
  async (config) => {
    const token = await getToken();
    if (token) config.headers.Authorization = `Bearer ${token}`;

    const tenant = getCurrentTenant();
    if (tenant) config.headers["X-Tenant"] = tenant;

    return config;
  },
  (error) => Promise.reject(error)
);

export default api;